export const getFiltered = (data: any[], arr: string[]) => {
    const result: any[] = [];
    data.forEach((item) => {
        const filtered = item?.filter((passway: any) => arr.includes(passway.context.data_objects[0].marker));
        result.push(filtered);
    });
    return result;
};
